/**
 * Changes the input field of the form
 *
 * @param  {form} form The new text of the input field
 *
 * @return {object}    An action object with a type of CHANGE_USERNAME
 */
import {
  SAVE,
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_OVERSEAS_EMERGENCY_MEDICAL_OR_DENTAL_EXPENSES,
  RESET_ACCIDENTAL_DEATH,
  RESET_CONTACT_EMERGENCY_ASSISTANCE,
  RESET_LOSS_OF_INCOME,
} from './constants';

export function saveFormData(form) {
  return {
    type: SAVE,
    payload: form,
  };
}

export function loadFormData(form) {
  return {
    type: LOAD,
    payload: form,
  };
}

export function handleFormDataChange(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function nextSlide(errors) {
  return {
    type: NEXT,
    errors,
  };
}

export function resetFormData() {
  return {
    type: RESET,
  };
}

export function resetOverseasEmergencyMedicalOrDentalExpenses() {
  return {
    type: RESET_OVERSEAS_EMERGENCY_MEDICAL_OR_DENTAL_EXPENSES,
  };
}

export function resetAccidentalDeath() {
  return {
    type: RESET_ACCIDENTAL_DEATH,
  };
}

export function resetContactEmergencyAssistance() {
  return {
    type: RESET_CONTACT_EMERGENCY_ASSISTANCE,
  };
}

export function resetLossOfIncome() {
  return {
    type: RESET_LOSS_OF_INCOME,
  };
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepOverseasMedical/actions.js